import { render, staticRenderFns } from "./Akt.vue?vue&type=template&id=173cd19e"
import script from "./Akt.vue?vue&type=script&lang=ts"
export * from "./Akt.vue?vue&type=script&lang=ts"
import style0 from "./Akt.vue?vue&type=style&index=0&id=173cd19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports